export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
// user login logout
export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const SELECT_CURRENT_DOCUMENT = "SELECT_CURRENT_DOCUMENT";
export const SET_DOCUMENT_LIST = "SET_DOCUMENT_LIST";
export const SET_SAS_TOKEN = "SET_SAS_TOKEN";
export const SET_IP_ADDRESS = "SET_IP_ADDRESS";
export const SET_USER_PAGE = "SET_USER_PAGE";